const BLOCK_SELECTOR = '.wp-block-ssm-down-arrow';
const ARROW_SELECTOR = '.wp-block-ssm-down-arrow__link';
const SECTION_WRAPPER_CLASS = 'wp-block-ssm-section-wrapper';

const prefersReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;

const findNextSection = (el) => {
    const section = el.closest(`.${SECTION_WRAPPER_CLASS}`);
    let sib = section?.nextElementSibling ?? null;
    while (sib && !sib.classList.contains(SECTION_WRAPPER_CLASS)) {
        sib = sib.nextElementSibling;
    }

    return sib;
};

const handleActivation = (e) => {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();

    const next = findNextSection(e.currentTarget);
    next?.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start',
    });
};

export const DownArrow = () => {
    document.querySelectorAll(BLOCK_SELECTOR).forEach((el) => {
        if (el.dataset.downArrowInit) return;
        el.dataset.downArrowInit = '1';

        const link = el.querySelector(ARROW_SELECTOR);
        if (!link) return;

        link.addEventListener('click', handleActivation, { passive: false });
        link.addEventListener('keydown', handleActivation);
    });
};
